import "@/App.css";
import "@/index.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import Landing from "@/pages/Landing";
import Denunciar from "@/pages/Denunciar";
import Acompanhar from "@/pages/Acompanhar";
import Login from "@/pages/Login";
import Registro from "@/pages/Registro";
import GestorDashboard from "@/pages/GestorDashboard";
import SuperAdmin from "@/pages/SuperAdmin";
import Privacidade from "@/pages/Privacidade";
import Termos from "@/pages/Termos";
import Sobre from "@/pages/Sobre";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import PaymentMPResult from "@/pages/PaymentMPResult";

function Protected({ roles, children }) {
  const { user } = useAuth();
  const location = useLocation();
  if (user === null) return <div className="min-h-screen grid place-items-center text-slate-400">Carregando…</div>;
  if (!user) return <Navigate to="/login" state={{ from: location }} replace />;
  if (roles && !roles.includes(user.role)) return <Navigate to="/" replace />;
  return children;
}

function Shell({ children }) {
  return (
    <div className="App min-h-screen flex flex-col">
      <Navbar />
      <main className="flex-1">{children}</main>
      <Footer />
    </div>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster theme="dark" position="top-right" richColors />
        <Routes>
          <Route path="/" element={<Shell><Landing /></Shell>} />
          <Route path="/denunciar" element={<Shell><Denunciar /></Shell>} />
          <Route path="/denunciar/:slug" element={<Shell><Denunciar /></Shell>} />
          <Route path="/acompanhar" element={<Shell><Acompanhar /></Shell>} />
          <Route path="/login" element={<Shell><Login /></Shell>} />
          <Route path="/registro" element={<Shell><Registro /></Shell>} />
          <Route path="/privacidade" element={<Shell><Privacidade /></Shell>} />
          <Route path="/termos" element={<Shell><Termos /></Shell>} />
          <Route path="/vixvox" element={<Shell><Sobre /></Shell>} />
          <Route path="/payment/success" element={<Shell><PaymentSuccess /></Shell>} />
          <Route path="/payment/cancel" element={<Shell><PaymentCancel /></Shell>} />
          <Route path="/payment/mp/result" element={<Shell><PaymentMPResult /></Shell>} />
          <Route path="/gestor" element={<Protected roles={["tenant_admin", "compliance_manager"]}><Shell><GestorDashboard /></Shell></Protected>} />
          <Route path="/admin" element={<Protected roles={["super_admin"]}><Shell><SuperAdmin /></Shell></Protected>} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
